import { render, staticRenderFns } from "./IncidentDelete.vue?vue&type=template&id=d54974a2"
import script from "./IncidentDelete.vue?vue&type=script&lang=js"
export * from "./IncidentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports